export default __webpack_public_path__ + "static/media/dashboard_img.98653fbc.jpg";